let errors = 0;
//public functions

/**
 * add custom validation rules
 * @param {*} validationForm
 */
const addValidationRules = validationForm => {
  validationForm.addValidationRule("isMinLengthValid", value => {
    if (value.length < 3) {
      return false;
    } else {
      return true;
    }
  });

  validationForm.addValidationRule("isMaxLengthValid", value => {
    if (value.length > 50) {
      return false;
    } else {
      return true;
    }
  });

  validationForm.addValidationRule("isNumberValid", value => {
    if (isNaN(value) || value < 0) {
      return false;
    } else {
      return true;
    }
  });

  validationForm.addValidationRule("isRequired", value => {
    if (value === "") {
      return false;
    } else {
      return true;
    }
  });
};

/**
 * get form's global status (valid/invalid)
 */
const getFormValidationStatus = () => {
  if (errors > 0) return false;
  else return true;
};

//export statement
module.exports = {
  addValidationRules,
  getFormValidationStatus
};



// WEBPACK FOOTER //
// ./src/utils/formValidation/ValidationRules.js